// @flow

import React, { useEffect, useState } from 'react';
import styles from './styles.module.scss';

const FreeModal = ({ visible, forControl }: boolean) => {
  const [language, setLanguage] = useState<string>('');
  const getLanguage = () => {
    const lang = localStorage.getItem('i18nextLng');
    if (lang?.includes('ru')) return 'ru';
    if (lang?.includes('en')) return 'en';
    return 'en';
  };

  useEffect(() => {
    setLanguage(getLanguage());
  }, []);

  const mapSentenses = new Map();
  mapSentenses.set('en', [
    'Upgrade your subscription to access this feature',
  ]);
  mapSentenses.set('ru', [
    'Обновите подписку для доступа к этой функции',
  ]);

  return (
    (visible && (
      <div className={`${styles.modalWrap} ${forControl ? styles.forControl : styles.default}`}>
        {mapSentenses.get(language)?.map((item, idx) => (
        // eslint-disable-next-line react/no-array-index-key
          <div key={idx}>
            {item}
          </div>
        ))}
      </div>
    )
    )
  );
};

export default FreeModal;
